import Cookie from "cookie-universal";
export const cookie = Cookie();

export const REGISTER = `register`;
export const LOGIN = `login`;
export const PROFILE = `profile`;
export const LOGOUT = `logout`;
export const USERS = `users`;

export const QUESTION = `question`;
export const userQUESTIONS = `userQuestions`;
export const QUESTIONS = `questions`;
export const ANSWERS = `answers`;
export const ANSWER = `answer`;
